module.exports = __webpack_public_path__ + "img/Orange.f94be524.jpg";